
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ReportPendingPRDialog extends Serenity.EntityDialog<ReportPendingPRRow, any> {
        protected getFormKey() { return ReportPendingPRForm.formKey; }
        protected getIdProperty() { return ReportPendingPRRow.idProperty; }
        protected getLocalTextPrefix() { return ReportPendingPRRow.localTextPrefix; }
        protected getNameProperty() { return ReportPendingPRRow.nameProperty; }
        protected getService() { return ReportPendingPRService.baseUrl; }
        protected getDeletePermission() { return ReportPendingPRRow.deletePermission; }
        protected getInsertPermission() { return ReportPendingPRRow.insertPermission; }
        protected getUpdatePermission() { return ReportPendingPRRow.updatePermission; }

        protected form = new ReportPendingPRForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
         
             let newCloseBtn: Serenity.ToolButton =
            {
                title: Q.text("ปิดเอกสาร"),
                hint: "Close Document",
                separator: false,
                cssClass: "closed-button",
                icon: "fa fa-save",
                onClick: (e) => {
                    Q.confirm('ยืนยันการปิดเอกสาร', () => {
                        // this.doDelete(() => {
                        console.log("Document Closed",this.form.SysDocNo.value);
                        //     this.dialogClose();
                        // });
                        Q.serviceRequest('Purchase/PoPurRequest/UpdateCancelAndUseFg', {
                            sysDocNo: this.form.SysDocNo.value,
                            CancelFg: "1",
                            UseFg: 1
                        }, response => {
                            Q.notifySuccess("ปิดเอกสารเรียบร้อยแล้ว");
                            this.dialogClose();
                        }, {
                            onError: (response) => {
                                Q.notifyError("เกิดข้อผิดพลาดในการปิดเอกสาร");
                            }
                        });

                    });
                }
            };
            buttons.push(newCloseBtn);
           return buttons;


   }


    }
}